(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["square-shoppable-image"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sq-product-hotspots')) {
    customElements.define('sq-product-hotspots', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.init());
      }
      init() {
        if (!this.isConnected || this.controller) return;
        this.stage = this.querySelector('[data-stage]');
        if (!this.stage) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reposition = () => {
          cancelAnimationFrame(this.positionFrame);
          this.positionFrame = requestAnimationFrame(() => this.positionCard());
        };
        this.addEventListener('click', (event) => {
          const pin = event.target.closest('[data-pin]');
          if (pin && this.contains(pin)) {
            if (this.activePin === pin) this.close();
            else this.open(pin);
          }
          if (event.target.closest('[data-close]')) this.close(true);
        }, options);
        document.addEventListener('click', (event) => {
          if (!this.activePin) return;
          if (!this.activePin.contains(event.target) && !this.activeCard.contains(event.target)) this.close();
        }, options);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.activePin) this.close(true);
        }, options);
        this.addEventListener('focusout', (event) => {
          if (!this.activePin || !event.relatedTarget) return;
          if (!this.activePin.contains(event.relatedTarget) && !this.activeCard.contains(event.relatedTarget)) this.close();
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          const pin = Array.from(this.querySelectorAll('[data-pin]')).find((node) => node.dataset.block === event.detail.blockId);
          if (pin) this.open(pin);
        }, options);
        document.addEventListener('shopify:block:deselect', (event) => {
          if (this.activePin && this.activePin.dataset.block === event.detail.blockId) this.close();
        }, options);
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.reposition);
          this.observer.observe(this.stage);
        }
        window.addEventListener('resize', this.reposition, options);
      }
      open(pin) {
        const card = document.getElementById(pin.getAttribute('aria-controls'));
        if (!card || !this.contains(card)) return;
        this.close();
        this.activePin = pin;
        this.activeCard = card;
        pin.setAttribute('aria-expanded', 'true');
        card.hidden = false;
        this.positionCard();
      }
      close(restoreFocus = false) {
        const pin = this.activePin;
        if (this.activeCard) this.activeCard.hidden = true;
        if (pin) pin.setAttribute('aria-expanded', 'false');
        this.activePin = null;
        this.activeCard = null;
        if (restoreFocus && pin && pin.isConnected) pin.focus({ preventScroll: true });
      }
      positionCard() {
        if (!this.activePin || !this.activeCard) return;
        const pin = this.activePin;
        const card = this.activeCard;
        const stageWidth = this.stage.clientWidth;
        const stageHeight = this.stage.clientHeight;
        const width = card.offsetWidth;
        const height = card.offsetHeight;
        const x = pin.offsetLeft;
        const y = pin.offsetTop;
        const gap = pin.offsetWidth / 2 + 10;
        let side = pin.dataset.side;
        if (window.innerWidth < 750) side = 'bottom';
        if (side === 'right' && x + gap + width > stageWidth - 8) side = 'left';
        else if (side === 'left' && x - gap - width < 8) side = 'right';
        else if (side === 'bottom' && y + gap + height > stageHeight - 8) side = 'top';
        else if (side === 'top' && y - gap - height < 8) side = 'bottom';
        let left = x - width / 2;
        let top = y - height / 2;
        if (side === 'right') left = x + gap;
        if (side === 'left') left = x - gap - width;
        if (side === 'bottom') top = y + gap;
        if (side === 'top') top = y - gap - height;
        // 边缘空间不足时，限制在方形图片内部，不伸到相邻分区。
        left = Math.max(8, Math.min(left, stageWidth - width - 8));
        top = Math.max(8, Math.min(top, stageHeight - height - 8));
        card.style.left = `${left}px`;
        card.style.top = `${top}px`;
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.positionFrame);
        this.close();
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
